export * from './src/simple.translation'